module.exports = __webpack_public_path__ + "static/img/Mitch-Langerak.65420a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch-Langerak.jpg
// module id = 3T1d
// module chunks = 0